// extracted by mini-css-extract-plugin
export default {"statics":"Statics_statics__oDbGQ","active":"Statics_active__b132R"};